function convertToReadable(number: any) {
    const num = isNaN(Number(number)) ? 0 : Math.abs(Number(number));  

    function isFloat(n: any) {
        return Number(n) === n && n % 1 !== 0;
    }

    let newValue;
    if (isFloat(Number(num))) {
        newValue = num.toString().split('.');
        newValue[0] = newValue[0]?.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
        newValue = newValue.join('.');
    } else {
        newValue = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    }

    return newValue || "0";
}

// eslint-disable-next-line import/no-anonymous-default-export
export default convertToReadable;